import React, { useMemo } from 'react';

interface HorariosAtencionType {
  horaInicio: string;
  horaFin: string;
  diaSemana: string;
}

interface HorariosAtencionProps {
  value?: HorariosAtencionType[];
}

const HorariosAtencion: React.FC<HorariosAtencionProps> = ({
  value = [],
}) => {
  const horariosAgrupados = useMemo(() => {
    const grupos: Record<string, HorariosAtencionType[]> = {};
    value.forEach(h => {
      if (!grupos[h.diaSemana]) grupos[h.diaSemana] = [];
      grupos[h.diaSemana].push(h);
    });
    return grupos;
  }, [value]);

  return (
    <div className="ml-2">
      {Object.keys(horariosAgrupados).map(dia => (
        <div key={dia} className="mb-2">
          <strong>{dia}:</strong>{' '}
          {horariosAgrupados[dia]
            .map(h => `${h.horaInicio} - ${h.horaFin}`)
            .join(' | ')}
        </div>
      ))}
    </div>
  );
};

export default HorariosAtencion;
